export default __webpack_public_path__ + "static/media/mem3.12b82471.png";